var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 243,
    viewBox: "0 0 275 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1973_5431)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_1973_5431)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.035 38.7365C170.972 37.9516 170.601 37.2236 170.002 36.7125C169.403 36.2015 168.626 35.9493 167.841 36.0115L84.9752 42.5748C76.3413 43.2586 68.3326 47.3443 62.711 53.9329C57.0895 60.5216 54.3155 69.0736 54.9993 77.7075L68.1259 243.438C68.8098 252.072 72.8954 260.081 79.4841 265.703C86.0728 271.324 94.6247 274.098 103.259 273.414L221.638 264.038C230.272 263.354 238.281 259.269 243.902 252.68C249.524 246.091 252.298 237.539 251.614 228.905L242.375 112.266C242.313 111.481 241.942 110.753 241.343 110.242C240.744 109.731 239.967 109.479 239.182 109.541L185.911 113.761C183.556 113.947 181.224 113.19 179.427 111.657C177.63 110.124 176.516 107.94 176.329 105.585L171.035 38.7365ZM178.602 167.218C180.558 168.544 182.962 169.04 185.283 168.594C187.605 168.149 189.655 166.8 190.981 164.843C192.308 162.887 192.803 160.484 192.358 158.162C191.913 155.84 190.564 153.791 188.607 152.464L157.213 131.186C155.53 130.02 153.496 129.471 151.455 129.629L151.36 129.636C149.357 129.81 147.472 130.656 146.011 132.037L118.325 158.031C116.602 159.647 115.592 161.882 115.516 164.244C115.441 166.606 116.307 168.901 117.923 170.624C119.54 172.347 121.775 173.358 124.136 173.433C126.498 173.509 128.793 172.643 130.516 171.026L144.719 157.679L147.944 198.402C148.037 199.568 148.358 200.704 148.889 201.746C149.421 202.788 150.152 203.715 151.042 204.474C151.932 205.233 152.962 205.81 154.075 206.17C155.187 206.531 156.36 206.669 157.526 206.577C158.692 206.485 159.828 206.164 160.87 205.632C161.912 205.101 162.839 204.369 163.598 203.479C164.357 202.59 164.933 201.559 165.294 200.447C165.655 199.334 165.793 198.161 165.701 196.995L162.476 156.273L178.602 167.218Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_1973_5431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.095 41.1656C188.923 38.9874 191.098 37.4214 192.898 38.6487C194.427 39.6951 195.808 40.9436 197.043 42.3944L236.645 89.2532C237.54 90.3259 236.781 91.8631 235.384 91.9738L196.342 95.066C195.557 95.1282 194.78 94.876 194.181 94.365C193.582 93.8539 193.211 93.1259 193.148 92.341L189.095 41.1656Z",
    fill: "#FDF9FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_1973_5431",
    x: 13.8568,
    y: 36.0022,
    width: 278.9,
    height: 329.856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35922
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1973_5431"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.16599
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26639
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.047 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1973_5431",
    result: "effect2_dropShadow_1973_5431"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.3759
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.15031
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1973_5431",
    result: "effect3_dropShadow_1973_5431"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51.3008
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.086 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1973_5431",
    result: "effect4_dropShadow_1973_5431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1973_5431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_1973_5431",
    x: 148.045,
    y: 38.2175,
    width: 130.028,
    height: 149.199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35922
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1973_5431"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.16599
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26639
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.047 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1973_5431",
    result: "effect2_dropShadow_1973_5431"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.3759
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.15031
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1973_5431",
    result: "effect3_dropShadow_1973_5431"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51.3008
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.086 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1973_5431",
    result: "effect4_dropShadow_1973_5431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1973_5431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1973_5431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285,
    height: 285,
    fill: "white",
    transform: "translate(0 22.5027) rotate(-4.52862)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.57f7be6fc9acd6337862c9e9801529ec.svg";
export { ForwardRef as ReactComponent };